import React from 'react'
import { connect } from 'react-redux'
import { Modal } from 'react-overlays'
import { AppState } from '../reducers'

const backdropStyle = {
    position: 'fixed',
    zIndex: 1040,
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#000',
    opacity: 0.5
}

const modalStyle = function () {
    return {
        position: 'absolute',
        width: 400,
        zIndex: 1040,
        border: '1px solid #e5e5e5',
        'borderRadius': '0 0 10px 10px',
        backgroundColor: 'white',
        boxShadow: '0 5px 15px rgba(0,0,0,.5)',
        padding: 15,
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)'
    }
}

const COLOR = 'COLOR'
const SIZE = 'SIZE'

interface UpdateBtnModalProps extends ReturnType<typeof mapStateToProps> {
    show: boolean
    closeModal
    sendPositions
}

interface UpdateBtnModalState {
    checkedColors: number[]
    checkedSizes: number[]
}

class UpdateBtnModal extends React.Component<UpdateBtnModalProps, UpdateBtnModalState> {
    constructor(props) {
        super(props)

        this.state = {
            checkedColors: [],
            checkedSizes: []
        }
    }

    handleChange(e) {
        const value = e.target.value
        const result = value.split('-')
        const isChecked = e.target.checked
        if (result[0] === COLOR) {
            let list = []
            list = list.concat(this.state.checkedColors)

            if (isChecked) {
                list.push(parseInt(result[1], 10))
                this.setState(({ checkedColors: list }))
            } else {
                let index = this.state.checkedColors.findIndex(c => c === parseInt(result[1], 10))
                if (index > -1) {
                    list.splice(index, 1)
                    this.setState(({ checkedColors: list }))
                }
            }
        } else if (result[0] === SIZE) {
            let list = []
            list = list.concat(this.state.checkedSizes)

            if (isChecked) {
                list.push(parseInt(result[1], 10))
                this.setState(({ checkedSizes: list }))
            } else {
                let index = this.state.checkedSizes.findIndex(s => s === parseInt(result[1], 10))
                if (index > -1) {
                    list.splice(index, 1)
                    this.setState(({ checkedSizes: list }))
                }
            }
        }
    }

    onCloseModal() {

    }

    renderBackdrop(props) {
        return <div {...props} style={backdropStyle} />
    }

    render() {
        return (
            <Modal
                placement='right'
                onHide={this.props.closeModal}
                style={modalStyle()}
                aria-labelledby="modal-label"
                show={this.props.show}
                renderBackdrop={this.renderBackdrop}
                onShow={() => {
                    this.setState({ checkedColors: [], checkedSizes: [] })
                }}
            >
                <div id="update-data">
                    <h3>Aktualizacja pozycji asortymentu dla aktualnie wybranych filtrów.</h3>
                    <button
                        style={{ borderRadius: "5px", margin: '0 5px 0 0', padding: "5px" }}
                        className="kr-button"
                        onClick={() => {
                            if (window.confirm('Czy na pewno chcesz zaktualizować asortyment?')) {
                                this.props.closeModal()
                                this.props.sendPositions(this.state)
                            }
                        }}
                    >
                        <span>Zatwierdź</span>
                    </button>
                    <button
                        style={{ borderRadius: "5px", margin: '0 5px', padding: "5px" }}
                        onClick={() => { this.props.closeModal() }}
                    >
                        <span>Anuluj</span>
                    </button>
                </div>
            </Modal>
        )
    }
}

const mapStateToProps = (state: AppState) => ({
    assortment: state.filteredAssortment
})

export default connect(mapStateToProps)(UpdateBtnModal)
